import { createApp, ComponentPublicInstance } from "vue";
import Toast, { ToastParams } from "@/components/Toast/Toast.vue";

interface ToastInstance extends ComponentPublicInstance {
  showInfo: (options: ToastParams) => void;
  hide: () => void;
}

class ToastService {
  private instance: ToastInstance | null;

  constructor() {
    this.instance = null;
    this.initialize();
  }

  initialize() {
    const toastDiv = document.createElement("div");
    document.body.appendChild(toastDiv);

    const toastApp = createApp(Toast);
    this.instance = toastApp.mount(toastDiv) as ToastInstance;
  }

  showToast(message: string, options?: ToastParams) {
    if (!this.instance || !message) return;
    let params: ToastParams;
    params = { title: message, ...(options || {}) };
    return this.instance.showInfo(params);
  }

  hideToast() {
    return this.instance.hide();
  }
}

// 创建单例
export const toastService = new ToastService();

// 定义 Vue 插件
export default {
  install: (app) => {
    // 添加全局方法
    app.config.globalProperties.$showToast = (message: string, options?: ToastParams) => toastService.showToast(message, options);
    app.config.globalProperties.$hideToast = () => toastService.hideToast();

    // 同时提供依赖注入方式
    app.provide("$toast", {
      showToast: (message: string, options?: ToastParams) => toastService.showToast(message, options),
      hideToast: () => toastService.hideToast(),
    });
  },
};

/** 断网/弱网提示语 */
export const TOAST_NO_NETWORK = "网络有点问题，请检查设置~";
